export enum HitTestBehavior {
  deferToChild,
  opaque,
  translucent,
}
